<template>
    <div>
        <MercenaryHeader :title="''" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div v-if="is_loaded" style="overflow:auto;">
            <div style="display:flex; padding:20px 0px;">
                <div style="width:60px; display:flex; justify-content: center;">
                    <img v-if="join_schedule_slider_images && join_schedule_slider_images.length > 0" :src="$resourcePath + join_schedule_slider_images[0].thumb_image_path" style="width:40px; height:40px; border-radius:8px;">
                </div>
                <div style="flex:1; padding-top:3px;">
                    <div style="color:#210F03; font-weight:bold; font-size:14px;" @click.stop="showTeamTrainingDetail(join_schedule.idx)">{{join_schedule.title}}<img :src="require('@/assets/images/mypage/ico-move.png')" style="width:7px; margin-left:5px;"></div>
                    <div style="font-size:12px; color:#808080; font-weight:500; margin-top:3px;" @click.stop="showTeamTrainingDetail(join_schedule.idx)">{{join_schedule.creator.nic_name}}
                        <img v-if="join_schedule.creator.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" :src="require('@/assets/img/blue_star.png')" style="vertical-align:bottom;width:12px; height:12px;">
                        <img v-else :src="require('@/assets/img/yellow_star.png')" style="vertical-align:bottom;width:12px; height:12px;">
                    </div>
                    <div style="font-size:12px; font-weight:500; color:#606060;margin-top:5px; display: flex; align-items: center;flex-wrap: wrap; line-height:20px;">
                        {{$Util.getMMDDDayHangulStr(join_schedule.join_date)}} {{join_schedule.begin_time}}~{{join_schedule.end_time}}
                        <div style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: rgba(33, 15, 3, 0.698); margin:0px 5px; line-height:20px;"></div>
                        <div style="display: inline-block;  line-height:20px;">{{join_schedule.place_name}}</div>
                    </div>
                    <div style="display:flex; margin-top:10px;">
                        <div class="training_btn" @click="showTeamTrainingNoticeForm">공지사항 관리</div>
                        <div class="training_btn" @click="showTeamTrainingForm">수정</div>
                        <div v-if="repeatScheduleInfo.idx" class="training_btn" @click="showTeamTrainingCopyForm">복사</div>
                        <div v-if="repeatScheduleInfo.days && repeatScheduleInfo.is_stop == '0'" class="training_btn" @click="toggleRepeatScheduleStop(repeatScheduleInfo.is_stop)">중지</div>
                        <div v-if="repeatScheduleInfo.days && repeatScheduleInfo.is_stop == '1'" class="training_btn" @click="toggleRepeatScheduleStop(repeatScheduleInfo.is_stop)">재개</div>
                    </div>
                </div>
            </div>

            <div style="height:1px; background-color: #f5f5f5;"></div>

            <div style="padding:12px;">
                <div class="sub_title">조회수 및 성과</div>
                <div style="display:grid; place-items: center; padding:30px;">
                    <div style="color:#210F03; font-size:20px; font-weight:bold;">{{join_schedule.view_cnt | comma}}</div>
                    <div style="color:#808080; font-size:14px; margin-top:8px; ">전체 조회수</div>
                    <div style="color:#210F03; font-size:20px; font-weight:bold; margin-top:20px;">{{total_try_cnt | comma}}</div>
                    <div style="color:#808080; font-size:14px; margin-top:8px; ">전체 클릭수</div>
                </div>

                <div>
                    <swiper ref="filterSwiper" :options="swiperOption" role="tablist" style="height:300px;">
                        <swiper-slide style="display:grid;place-items: center;">
                            <div style="width:80%; height:250px; border:1px solid #EBEBEB; border-radius:12px; text-align:center;">
                                <div style="display:inline-block;">
                                    <div style="font-size:16px; font-weight:500; color:#210F03; margin-top:20px;">나이대</div>
                                    <div style="margin-top:10px; font-size:14px; font-weight:500; color:#808080;">클릭수 (전체기간)</div>
                                    <div style="margin-top:20px;">
                                        <div v-for="each, key in age_try_stats" :key="key" style="display:flex; width:260px; margin-top:10px; gap:10px; align-items: center;">
                                            <div style="font-size:14px; color:#808080;width:80px; text-align:right;">{{key}}</div>
                                            <div style="border-radius:4px; flex:1; display:flex; overflow:hidden; height:20px;">
                                                <div class="" style="background-color: var(--color-main);" :style="{flex : each}"></div>
                                                <div class="" style="background-color:#EBEBEB;" :style="{flex : (100 - each)}"></div>
                                            </div>
                                            <div style="font-size:14px; color:#808080; width:80px; text-align:left;">{{each}}%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide style="display:grid;place-items: center;">
                            <div style="width:80%; height:250px; border:1px solid #EBEBEB; display:grid; place-items: center; border-radius:12px;">
                                <div>
                                    <div style="font-size:16px; font-weight:500; color:#210F03; margin-top:20px; text-align:center;">성별</div>
                                    <div style="margin-top:10px; font-size:14px; font-weight:500; color:#808080; text-align:center;">클릭한 성별(전체기간)</div>
                                </div>

                                <div class="chart_wrap" id="pie_chart" style="width:100%; margin-top:5px;"></div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; bottom: 0px; height: 20px; text-align: center; z-index: 10; display:inline-block; left:50%; width:50px; transform:translateX(-50%)"></div>
                    </swiper>
                    <div style="height:30px;"></div>
                </div>

            </div>

            <div style="height:20px; background-color: #f5f5f5;"></div>

            <div style="padding:12px; margin-top:10px;">
                <div class="sub_title">신청 회원<span style="margin-left:10px;">{{apply_members.length}}명</span></div>
                <div v-for="each, i in apply_members" :key="i" style="display: flex; align-items: center; gap: 8px; padding-bottom: 10px; padding-top: 12px;" @click="showProfile(each)">
                    <div>
                        <ProfileImage style="width: 40px;" :image-path="each.image_path"></ProfileImage>
                    </div>
                    <div style="flex: 1; font-weight: 700; font-size: 14px; line-height: 24px;">{{ each.nic_name }} <span style="font-weight: 700; color: var(--color-main);">{{ each.position }}</span></div>
                    <div>
                        <div style="border-radius:12px; background-color: #F5F5F5; display:grid;place-items: center; color:var(--color-main); font-size:14px; font-weight:bold; padding:8px 15px;" @click.stop="showPersonalChat(each)">메시지</div>
                    </div>
                </div>
            </div>

            <div style="height:1px; background-color: #f5f5f5;"></div>

            <div style="padding:12px; margin-top:10px;">
                <div class="sub_title">취소 회원<span style="margin-left:10px;">{{cancel_members.length}}명</span></div>
                <div v-for="each, i in cancel_members" :key="i" style="display: flex; align-items: center; gap: 8px; padding-bottom: 10px; padding-top: 12px;" @click="showProfile(each)">
                    <div>
                        <ProfileImage style="width: 40px;" :image-path="each.image_path"></ProfileImage>
                    </div>
                    <div style="flex: 1; font-weight: 700; font-size: 14px; line-height: 24px;">{{ each.nic_name }} <span style="font-weight: 700; color: var(--color-main);">{{ each.position }}</span></div>
                    <div>
                        <div style="border-radius:12px; background-color: #F5F5F5; display:grid;place-items: center; color:var(--color-main); font-size:14px; font-weight:bold; padding:8px 15px;" @click.stop="showPersonalChat(each)">메시지</div>
                    </div>
                </div>
            </div>

            <div style="height:20px; background-color: #f5f5f5;"></div>

            <div style="color:#4B8AFF; font-size:15px; font-weight:500; padding:12px; margin-top:10px;" @click="deleteTeamTraining">트레이닝 삭제하기</div>
        </div>

    </div>
</template>

<script>
    import MercenaryHeader from "../../common/MercenaryHeader";
    import {JOIN_CHAT_TYPE, JOIN_MEMBER_STATE, MEMBER_TYPE, TEAM_TYPE} from "../../../Constants";
    import ProfileImage from "../../common/ProfileImage";
    import ResponseCode from "../../../ResponseCode";
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import 'swiper/dist/css/swiper.min.css'

    export default {
        name: "TeamTrainingMngDetail",
        components: { swiper, swiperSlide, ProfileImage, MercenaryHeader},
        props : {
            join_schedule_idx : {
                type : [String, Number],
                default : -1
            },
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        data(){
            return {
                swiperOption: {
                    initialSlide: 0,
                    spaceBetween: 1, // swiper-slide 사이의 간격 지정
                    slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                    slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                    freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                    centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets'
                    },
                },
                apply_members : [],
                cancel_members : [],
                join_schedule : {},
                join_schedule_slider_images : [],
                is_loaded : false,
                repeatScheduleInfo: {},
                total_try_cnt : 0,
                age_try_stats : {},
                sex_try_stats : {},
                TEAM_TYPE: TEAM_TYPE
            }
        },
        methods : {
            showTeamTrainingDetail(join_schedule_idx){
                this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: join_schedule_idx })
            },
            async deleteTeamTraining(){
                let html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">해당 날짜 트레이닝을 삭제합니다<br>정말로 삭제하시겠습니까?</div>`;

                this.$GlobalStore.showConfirm(html, async () => {
                    const parameters = {};
                    parameters.join_schedule_idx = this.join_schedule_idx;
                    const res = await this.$Axios.post('/api/join/schedule/delete', parameters);
                    if(res.data.code === ResponseCode.SUCCESS){
                        this.$GlobalStore.closeLastModal();
                        this.completeAction();
                    }else if(res.data.code === ResponseCode.FAIL){
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, '삭제하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION6, false, () => { })


            },
            async toggleRepeatScheduleStop(is_stop){
                let html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">매주 스케줄이 자동 생성되는것을 정지합니다.<br>정말로 중지하시겠습니까?</div>`;
                let ok_btn_name = '중지하기';
                if(is_stop == '1'){
                    html = '<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">매주 스케줄이 자동 생성되는것을 재개합니다. 이전에 등록해둔 스케줄이 시작하기 전까지만 가능합니다.<br>정말로 재개하시겠습니까?</div>';
                    ok_btn_name = '재개하기';
                }

                this.$GlobalStore.showConfirm(html, async () => {
                    const parameters = {};
                    parameters.is_stop = '1';
                    parameters.repeat_schedule_idx = this.repeatScheduleInfo.idx;

                    const res = await this.$Axios.post('/api/join/repeat/schedule/save', parameters);
                    if(res.data.code === ResponseCode.SUCCESS){
                        this.getScheduleDetail();
                    }else if(res.data.code === ResponseCode.FAIL){
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, ok_btn_name, '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION6, false, () => { })

            },
            setSexPieChart(){
                let women_percent = this.sex_try_stats['여'];
                let men_percent = this.sex_try_stats['남'];

                let is_zero = false;
                if(men_percent == 0 && women_percent == 0){
                    men_percent = 1;
                    women_percent = 1;
                    is_zero = true;
                }

                /* eslint-disable no-undef*/
                window.google.charts.load('current', {packages: ['corechart']});
                window.google.charts.setOnLoadCallback(() => {
                    const sexEnterData = [
                        ['Task', 'Hours per Day'],
                        ['남자', men_percent],
                        ['여자', women_percent]
                    ];

                    let men_color = '#ffbc47';
                    let women_color = '#ff7111';

                    if(is_zero){
                        men_color = '#d9d9d9';
                        women_color = '#ebebeb';
                    }

                    const data = window.google.visualization.arrayToDataTable(sexEnterData);
                    const options = {
                        // title: '성별',
                        titleTextStyle : {
                            fontSize:'15'
                        },
                        slices: {
                            0: { color: men_color },
                            1: { color: women_color }
                        },
                        chartArea: {width: '90%'},
                        legend : {
                            alignment : 'center',
                            position : 'top',
                            textStyle : {
                                fontSize : 13,
                            },
                        },
                        backgroundColor : 'transparent',
                        pieStartAngle : is_zero ? 180 : 0,
                        sliceVisibilityThreshold: 0,
                    };

                    const chart = new window.google.visualization.PieChart(document.getElementById('pie_chart'));
                    chart.draw(data, options);
                });

            },
            showTeamTrainingCopyForm(){
                this.$GlobalStore.addModal('MakeClassScheduleFeedPopup', {scheduleIdx: this.join_schedule_idx, completeAction: () => {
                        this.getScheduleDetail();
                    }, isCopy : true})
            },
            showTeamTrainingForm(){
                this.$GlobalStore.addModal('MakeClassScheduleFeedPopup', {scheduleIdx: this.join_schedule_idx, completeAction: this.getScheduleDetail })
            },

            showTeamTrainingNoticeForm(){
                this.$GlobalStore.addModal('TeamTrainingNoticeForm', {join_schedule_idx : this.join_schedule.repeat_schedule_idx});
            },
            async showPersonalChat(member){
                await this.$Axios.showPersonalChat(member.member_idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.SINGLE);
            },
            async getScheduleDetail() {
                const parameters = {}
                parameters.join_schedule_idx = this.join_schedule_idx;
                parameters.is_from_mng = true;

                const res = await this.$Axios.get('/api/join/schedule/detail', { params: parameters });
                if (!res.data.join_schedules) {
                    this.$GlobalStore.showAlert('삭제된 수업입니다.');
                    this.$GlobalStore.closeLastModal();
                    return
                }

                this.is_loaded = true;
                this.join_schedule = res.data.join_schedules;
                this.join_schedule_slider_images = res.data.join_schedule_slider_images;
                this.repeatScheduleInfo = res.data.repeat_schedule;
                this.total_try_cnt = res.data.total_try_cnt;
                this.age_try_stats = res.data.age_try_stats;
                this.sex_try_stats = res.data.sex_try_stats;

                if(res.data.join_schedule_members){
                    const join_schedule_members = res.data.join_schedule_members;
                    const apply_member_states = [JOIN_MEMBER_STATE.APPLIED, JOIN_MEMBER_STATE.APPROVED];
                    const cancel_member_states = [JOIN_MEMBER_STATE.GETOUT, JOIN_MEMBER_STATE.REJECT, JOIN_MEMBER_STATE.APPLY_REJECT];

                    const my_member_idx = this.$GlobalStore.loginInfo().idx;

                    this.apply_members = join_schedule_members.filter(each => apply_member_states.indexOf(parseInt(each.state)) > -1).filter(each => each.member_idx != my_member_idx);
                    this.cancel_members = join_schedule_members.filter(each => cancel_member_states.indexOf(parseInt(each.state)) > -1);
                }

                this.setSexPieChart();

            },
            async showProfile(member){
                this.$Util.showProfile(member.member_idx, MEMBER_TYPE.USER, null, member.is_coach);
            }
        },
        created() {
            this.deleteTeamTraining = this.$Once(this.deleteTeamTraining);
            this.getScheduleDetail();
        }
    }
</script>

<style scoped>
    .sub_title{font-weight:bold; font-size:14px; color:#210F03;}
    .training_btn{color:var(--color-main); font-size:15px; font-weight:500;}
    .training_btn + .training_btn{margin-left:15px;}

    .swiper-pagination>>>.swiper-pagination-bullet {
        background-color: #ebebeb;
        width: 6px;
        height: 6px;
        opacity:1;
    }

    .swiper-pagination>>>.swiper-pagination-bullet-active {
        background-color: #ff7111;
    }
</style>